<script setup lang="ts">
import InputNumber from '@/components/BaseComponents/InputNumber.vue';
import { useCategories } from '@/composables/useCategories';
import { useEventBus } from '@/composables/useEventBus';
import { useFetch } from '@/composables/useFetch';
import { useOnboarding } from '@/composables/useOnboarding';
import { useSafeArea } from '@/composables/useSafeArea';
import type { MessageSchema } from '@/i18n';
import { useDishesStore } from '@/stores/dishesStore';
import { useEnvStore } from '@/stores/envStore';
import { type Ingredient } from '@/types/dish';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Sidebar from 'primevue/sidebar';
import { computed, onMounted, onUpdated, ref, watch, watchEffect, type ModelRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
const bus = useEventBus();

const { t, te } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
type IngredientEditing = Ingredient & {
  type?: 'ingredient' | 'group';
};

const onboarding = useOnboarding();
const { categories } = useCategories();
const { bottomSafeArea } = useSafeArea();

const showSideBar: ModelRef<boolean | undefined> = defineModel('visible', { type: Boolean, required: true });
const sideBarIngredient: ModelRef<IngredientEditing | null> = defineModel('ingredient', {
  type: Object as () => IngredientEditing | null,
  required: true,
});
// const ingredientCategory = { name: t('orders.ingredientsCategories.other'), value: 'other' };
const dishesStore = useDishesStore();
const ingredientUnits = ref(dishesStore.units);
const { fetchData } = useFetch();

const edition = ref(false);

const emit = defineEmits<{
  (event: 'ingredient-edited'): void;
  (event: 'delete-ingredient', index: number): void;
  (event: 'edit-ingredient'): void;
  (event: 'add-ingredient'): void;
}>();
// const ingredient = ref(props.ingredient);

const props = withDefaults(
  defineProps<{
    // ingredients: Ingredient[]
    showPrice?: boolean;
  }>(),
  {
    showPrice: false,
  },
);
onUpdated(() => {
  edition.value = sideBarIngredient.value?.id === -1 ? false : true;
});

onMounted(async () => {
  if (!ingredientUnits.value.length) {
    const { data, error } = await fetchData(useEnvStore().apiUrl + `/units/default`, 'GET');
    if (error) {
      console.log('error', error);
    } else {
      ingredientUnits.value = [{ symbol: '', name: t('ingredients.unit.symbol.noUnit') }, ...data];
    }
  }
  bus.on('onboarding:close-ingredient-sidebar', () => {
    console.log('[Sidebar] Fermeture demandée par Onboarding');
    showSideBar.value = false;
  });
});
const sideBarIngredientIndex = ref(0);
console.log('Side bar ingredient : ', sideBarIngredient.value);

watchEffect(() => {
  console.log('SIDEBAR INGREIDNET', sideBarIngredient.value?.category);
});

// watch(() => sideBarIngredient.value?.quantity, (newQuantity, oldQuantity) => {
//   if (sideBarIngredient.value && oldQuantity !== undefined && newQuantity !== undefined && sideBarIngredient.value.price) {
//     const oldPrice = sideBarIngredient.value.price;
//     const proportion = newQuantity / oldQuantity;
//     sideBarIngredient.value.price = oldPrice * proportion;
//   }
// });
// console.log("Side basr")
// console.log(sideBarIngredient.value)
// watch(sideBarIngredientIndex, (currentIngredient) => {
//   if (currentIngredient) {
//     sideBarIngredient.value = currentIngredient;
//   }
// });

function deleteIngredient() {
  // console.log("sidebar ingredient")
  // console.log(sideBarIngredient.value)
  // console.log("sideBar index", sideBarIngredient.value)
  if (sideBarIngredient.value && typeof sideBarIngredientIndex.value === 'number') {
    emit('delete-ingredient', sideBarIngredientIndex.value);
  }
  resetSideBarIngredient();
  showSideBar.value = false;
}

function addIngredient() {
  emit('add-ingredient');
  resetSideBarIngredient();
  showSideBar.value = false;
}

function editIngredient() {
  emit('edit-ingredient');
  resetSideBarIngredient();
  showSideBar.value = false;
}

function resetSideBarIngredient() {
  sideBarIngredient.value = {
    id: -1,
    category: categories.value[0].value,
    name: '',
    quantity: 0,
    unit: 'kg',
    price: 0,
  };
}

watch(
  () => sideBarIngredient.value,
  (newSideBarIngredient: Ingredient | null) => {
    if (!sideBarIngredient.value || !newSideBarIngredient) return;
    if (!newSideBarIngredient.name) {
      sideBarIngredient.value.name = '';
    }
    if (newSideBarIngredient.quantity === undefined || newSideBarIngredient.quantity === null) {
      sideBarIngredient.value.quantity = 0;
    }
    if (!newSideBarIngredient.unit) {
      sideBarIngredient.value.unit = 'kg';
    }
    if (!newSideBarIngredient.category) {
      sideBarIngredient.value.category = categories.value[0].value;
    }
    if (newSideBarIngredient.price === undefined || newSideBarIngredient.price === null) {
      sideBarIngredient.value.price = 0;
    }
    console.log('sideBarIngredient.value', sideBarIngredient.value);
  },
  { deep: true },
);

const isNameInvalid = computed(
  () => sideBarIngredient.value?.name === undefined || sideBarIngredient.value?.name === null || sideBarIngredient.value?.name === '',
);
const isQuantityInvalid = computed(() => {
  console.log(sideBarIngredient.value?.quantity);
  return sideBarIngredient.value?.quantity === undefined || sideBarIngredient.value?.quantity === null;
});
const isUnitInvalid = computed(
  () => sideBarIngredient.value?.unit === undefined || sideBarIngredient.value?.unit === null || sideBarIngredient.value?.unit === '',
);
const isCategoryInvalid = computed(() => sideBarIngredient.value?.category === undefined || sideBarIngredient.value?.category === null);

const isFormInvalid = computed(() => isNameInvalid.value || isQuantityInvalid.value || isUnitInvalid.value || isCategoryInvalid.value);

const router = useRouter();

function redirectToDishOrder(id: number) {
  router.push({ path: `/menu/dishes/${id}/add-to-orders` });
}

function handleDishOrderRedirect() {
  if (!onboarding.isOnboardingActive.value && sideBarIngredient.value?.dish_id) {
    redirectToDishOrder(sideBarIngredient.value.dish_id);
  }
}
</script>
<template>
  <Sidebar
    v-if="sideBarIngredient"
    v-model:visible="showSideBar"
    :header="`${edition ? t('profileFavorites.creationForm.editIngredientButton') : t('profileFavorites.creationForm.addIngredientButton')}`"
    position="bottom"
    style="height: auto"
    :block-scroll="true"
    class="onboarding-ingredient-detail w-full md:w-3/4 lg:w-1/2"
    :dismissable="!onboarding.isOnboardingActive.value"
    :show-close-icon="!onboarding.isOnboardingActive.value"
  >
    <div class="flex flex-col gap-4" :style="{ paddingBottom: bottomSafeArea }">
      <!-- Add dish link if dish_id exists -->
      <div
        v-if="sideBarIngredient.dish_id && sideBarIngredient?.is_from_shopping_list"
        class="cursor-pointer text-sm italic text-primary-600 hover:text-primary-700"
        @click="handleDishOrderRedirect"
      >
        <i class="pi pi-arrow-up-right"></i>
        {{ sideBarIngredient.dish_name || t('orders.viewDish') }}
      </div>

      <div class="flex flex-col">
        <label>{{ t('profileFavorites.creationForm.name') }}</label>
        <InputText
          v-model="sideBarIngredient.name"
          :placeholder="t('profileFavorites.creationForm.namePlaceholder')"
          :invalid="isNameInvalid"
          :disabled="(!!sideBarIngredient.dish_id && sideBarIngredient?.is_from_shopping_list) || onboarding.isOnboardingActive.value"
        />
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label>{{ t('profileFavorites.creationForm.quantityLong') }}</label>
          <InputNumber
            v-model="sideBarIngredient.quantity"
            :placeholder="t('profileFavorites.creationForm.quantityPlaceholder')"
            :step="0.01"
            mode="decimal"
            :invalid="isQuantityInvalid"
            :disabled="onboarding.isOnboardingActive.value"
          />
          <!-- <InputNumber
            v-model="sideBarIngredient.quantity"
            :placeholder="t('profileFavorites.creationForm.quantityPlaceholder')"
            :min-fraction-digits="2"
            :invalid="isQuantityInvalid"
          /> -->
        </div>
        <div class="flex flex-col">
          <label>{{ t('profileFavorites.creationForm.unit') }}</label>
          <!-- <InputText v-model="sideBarIngredient.unit"
            :placeholder="t('profileFavorites.creationForm.unitPlaceholder')" /> -->

          <Dropdown
            v-model="sideBarIngredient.unit"
            :options="ingredientUnits"
            option-label="symbol"
            option-value="symbol"
            :placeholder="t('profileFavorites.creationForm.unitPlaceholder')"
            class="w-full md:w-[14rem]"
            :invalid="isUnitInvalid"
            :disabled="onboarding.isOnboardingActive.value"
          >
            <template #value="slotProps">
              <div class="flex items-center">
                <div>
                  {{
                    slotProps.value === ''
                      ? t('ingredients.unit.symbol.noUnit') // Display "No Unit" if no unit is selected
                      : te(`ingredients.unit.symbol.${slotProps.value}`)
                        ? t(`ingredients.unit.symbol.${slotProps.value}`)
                        : slotProps.value
                  }}
                </div>
              </div>
              <!-- <span v-else>
                {{ slotProps.placeholder }}
              </span> -->
            </template>
            <template #option="slotProps">
              <div class="flex items-center">
                <div>
                  {{
                    slotProps.option.symbol === ''
                      ? t('ingredients.unit.symbol.noUnit') // Show "No Unit" in the dropdown option list
                      : te(`ingredients.unit.symbol.${slotProps.option.symbol}`)
                        ? t(`ingredients.unit.symbol.${slotProps.option.symbol}`)
                        : slotProps.option.symbol
                  }}
                </div>
              </div>
            </template>
          </Dropdown>
        </div>
        <div v-if="props.showPrice" class="flex flex-col">
          <label>{{ t('profileFavorites.creationForm.price') }}</label>
          <InputNumber
            v-model="sideBarIngredient.price"
            :placeholder="t('profileFavorites.creationForm.pricePlaceholder')"
            :step="0.01"
            mode="decimal"
            :disabled="onboarding.isOnboardingActive.value"
          />
        </div>
      </div>
      <Dropdown
        v-model="sideBarIngredient.category"
        :options="categories"
        option-label="name"
        option-value="value"
        :placeholder="t('ingredients.category.label')"
        class="w-full md:w-[14rem]"
        :invalid="isCategoryInvalid"
        :disabled="onboarding.isOnboardingActive.value"
      />
      <div class="flex items-center gap-3">
        <Button
          v-if="edition"
          type="button"
          icon="pi pi-trash"
          :aria-label="t('profileFavorites.creationForm.deleteIngredientButton')"
          severity="danger"
          :disabled="onboarding.isOnboardingActive.value"
          size="small"
          @click="deleteIngredient()"
        />
        <Button
          type="button"
          class="flex-1"
          :label="edition ? t('profileFavorites.creationForm.edit') : t('profileFavorites.creationForm.add')"
          :disabled="isFormInvalid || onboarding.isOnboardingActive.value"
          size="small"
          @click="edition ? editIngredient() : addIngredient()"
        />
      </div>
    </div>
    <!-- <div class="sticky z-50 flex gap-3 px-4 py-2 bg-white bottom-16"
      v-if="!isFetching || categoriesWithIngredients.length">
      <Button icon="pi pi-trash" aria-label="Delete" class="text-center" size="small"
        :disabled="!selectedIngredients.length"
        @click="!selectedIngredients.length ? null : confirmDeleteSelectedIngredients($event)" severity="danger" />
      <Button class="flex-1 text-center" size="small" :disabled="!selectedIngredients.length"
        @click="compareIngredients">
        {{ t('orders.createPurchaseOrder') }}
      </Button>
    </div> -->
  </Sidebar>
</template>
